export default __webpack_public_path__ + "static/media/pause.17441c19.svg";